/**
 * Stage — the top-level modal stage that hosts the slide deck, the
 * cinematic intro, and the optional opening animation (theatre
 * curtain / fade).
 *
 * Composition:
 *   <Stage>                                 ← phone-frame
 *     <DeckBackgroundLayer/>                ← z=1
 *     <PageTransitionStage>                 ← z=3..5 (page-transitions.css
 *           oldLayer={<PreviewSlide/>}
 *           newLayer={<PreviewSlide/>}        keeps iris / cover / etc.
 *         />                                    inside its own subtree)
 *     <OpeningCurtain/>                     ← z=50 (above chrome FX)
 *     <CinematicIntroOverlay/>              ← z=20
 *     <CinematicRespondDialog/>             ← z=20
 *     <PlayerControls/>                     ← z=10
 *     <PhoneFrameChromeLayer/>              ← wraps everything in p-2
 *   </Stage>
 *
 * Why split chrome + transitions + overlays: it lets the page
 * transition own its own z-index subtree (capped at 5) while keeping
 * the intro / respond dialog always on top at 20. The Stage doesn't
 * need to know about any individual layer's z-index.
 */
import type { CSSProperties, ReactNode } from 'react';
import './stage.css';

interface StageProps {
  children: ReactNode;
  /** Aspect-ratio of the phone frame. Defaults to 9 / 16. */
  style?: CSSProperties;
}

export function Stage({ children, style }: StageProps) {
  return (
    <div className="stage-root" style={{ aspectRatio: '9 / 16', ...style }}>
      <div className="stage-frame">{children}</div>
    </div>
  );
}
